import { TeamTimeline } from '@/model';
import {
  GetTeamTimelineByIdResponse,
  GetTeamTimelineItemResponse,
  GetTeamTimelineResponse,
  PostTeamTimelineResponse,
  PutTeamTimelineResponse,
} from '@/services/response/team-timeline';

export class TeamTimelineConverter {
  static toDomainFromGetItemResponse(response: GetTeamTimelineItemResponse): TeamTimeline {
    return {
      uuid: response.uuid,
      title: response.title,
      description: response.description,
      year: response.year,
      team_uuid: response.team_uuid,
      team_name: response.team_name,
      team_image: response.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPaginatedResponse(response: GetTeamTimelineResponse): TeamTimeline[] {
    return response.data.map(TeamTimelineConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromPostResponse(response: PostTeamTimelineResponse): TeamTimeline {
    return {
      uuid: response.uuid,
      title: response.title,
      description: response.description,
      year: response.year,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromByIdResponse(response: GetTeamTimelineByIdResponse): TeamTimeline {
    return {
      uuid: response.uuid,
      title: response.title,
      description: response.description,
      year: response.year,
      team_uuid: response.team_uuid,
      team_name: response.team_name,
      team_image: response.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutResponse(response: PutTeamTimelineResponse): TeamTimeline {
    return {
      uuid: response.uuid,
      title: response.title,
      description: response.description,
      year: response.year,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
